import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';

@Component({
  selector: 'app-previous-agenda-dialog',
  templateUrl: './previous-agenda-dialog.component.html',
  styleUrls: ['./previous-agenda-dialog.component.css']
})
export class PreviousAgendaDialogComponent implements OnInit,AfterViewInit {
  @Output() removePane = new EventEmitter<any>()
  @Output() toggleToLinkMeeting = new EventEmitter<any>()
  @ViewChild('viewPrevAgPaginator') viewPrevAgPaginator!:MatPaginator;
  @Input() prevAgendaInfoList!:any;
  @Input() curAgendaInfo!:any;//will hold the current info of clicked agenda
  agendaArrayContainer : any = [];
  spinner : any = false;
  loggedInUser:any=this.globals.userId;
  noteChecker : any=true;
  taskChecker : any=true;
  decisionChecker : any=true;
  agendaArray : any = [];

  constructor(public meetingService:MeetingService,private globals:Globals,public sideNav:SideNavServiceService) {
    
   }

  ngOnInit(): void {
    this.agendaArrayContainer=this.prevAgendaInfoList?.dataList;   
  }
  ngOnChanges() {
    this.agendaArrayContainer=this.prevAgendaInfoList?.dataList; 
    if(this.viewPrevAgPaginator!=undefined){
      this.viewPrevAgPaginator.length=this.prevAgendaInfoList?.totalCount; 
    }
  }
  ngAfterViewInit(): void {
  if(this.viewPrevAgPaginator!=undefined){
      this.viewPrevAgPaginator.length=this.prevAgendaInfoList?.totalCount;      
  }
}
//Added for pagination
  fetchPrevAgendaHis(){
    this.meetingService.fetchPrevAgendaHis(this.curAgendaInfo,this.viewPrevAgPaginator.pageIndex,this.viewPrevAgPaginator.pageSize).then((resp:any)=>{
      
      if(resp!=null){
        this.prevAgendaInfoList=resp;
        this.agendaArrayContainer=this.prevAgendaInfoList?.dataList;
        this.viewPrevAgPaginator.length=resp.totalCount;
      }
    });
  }
//to Fetch minutes for the agenda
  fetchAgendaMinutesList(index:any,curAgObj:any){
    var req={
      "agendaId":curAgObj.agendaId,
      "meetingId":curAgObj.meetingId,
    };
    this.spinner=true;
    this.meetingService.fetchAgendaMinutesList(req).subscribe((resp:any)=>{
      if(resp!=undefined && resp!=null && resp.body!=undefined && resp.body!=null && resp.body.minutesList!=null && resp.body.minutesList!=undefined){
        this.prevAgendaInfoList.dataList[index].agendaList[0].minutesList=resp.body.minutesList;
        this.agendaArrayContainer[index].agendaList[0].minutesList=resp.body.minutesList
        this.prevAgendaInfoList.dataList[index].agendaList[0].subtopics=resp.body.subtopics;
        this.agendaArrayContainer[index].agendaList[0].subtopics=resp.body.subtopics;
        this.agendaArray=resp.body;

      }
    }).add(()=>{
      this.spinner=false;
    });
  }
//added for note/decision/task toggle
  buttonTogglerEvent(arrayValue : any){
    
    let notes = 'notes';
    let task = 'task';
    let decision = 'decision';
    let noteIcon = <HTMLElement>document.getElementById('notes-icon');
    let taskIcon = <HTMLElement>document.getElementById('task-icon');
    let decisionIcon = <HTMLElement>document.getElementById('decision-icon')
    if(arrayValue.includes(notes) == true){
      this.noteChecker = true;
      noteIcon.setAttribute('style','color:white')
    }
    else{
      this.noteChecker = false;
      noteIcon.removeAttribute('style')
    }
    if(arrayValue.includes(task) == true){
      this.taskChecker = true;
      taskIcon.setAttribute('style','color:white')
    }
    else{
      this.taskChecker = false;
      taskIcon.removeAttribute('style')
    }
    if(arrayValue.includes(decision) == true){
      this.decisionChecker = true;
      decisionIcon.setAttribute('style','color:white')
    }
    else{
      this.decisionChecker = false;
      decisionIcon.removeAttribute('style')
    }
    
  }

  searchEvent(data : any){
 
  }

}
